import React from "react";
import {
    Box,
    Container,
    Heading,
    Text,
    VStack,
    Icon,
} from "@chakra-ui/react";
import { FaHardHat } from "react-icons/fa";
import { NavbarWithCallToAction } from "../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { brandConfig } from "../brandConfig";

const Terms = () => {
    return (
        <Box bg={brandConfig.colors.background.light} minHeight="100vh">
            <NavbarWithCallToAction />

            <Container maxW="1200px" py={20}>
                <VStack spacing={8} align="center" textAlign="center">
                    <Icon 
                        as={FaHardHat} 
                        w={20} 
                        h={20} 
                        color={brandConfig.colors.primary} 
                    />
                    
                    <Heading 
                        as="h1" 
                        size="2xl" 
                        color={brandConfig.colors.text.primary}
                    >
                        Terms and Conditions
                    </Heading>
                    
                    <Text 
                        fontSize="xl" 
                        color={brandConfig.colors.text.secondary}
                        maxW="600px"
                    >
                        This page is currently under construction.
                    </Text>
                    
                    <Text 
                        fontSize="lg" 
                        color={brandConfig.colors.text.muted}
                        maxW="600px"
                    >
                        Our terms and conditions are being finalized to ensure they provide 
                        clear guidelines for using SurgReady's preoperative preparation platform.
                        Please check back soon.
                    </Text>

                    <Box
                        bg={brandConfig.colors.background.surface}
                        p={8}
                        borderRadius="xl"
                        boxShadow={brandConfig.components.card.shadow}
                        border="1px solid"
                        borderColor={brandConfig.components.card.border}
                        mt={8}
                    >
                        <Text 
                            fontSize="md" 
                            color={brandConfig.colors.text.secondary}
                            fontWeight="medium"
                        >
                            For immediate assistance or questions about our terms of service, 
                            please contact us at support@surgready.com
                        </Text>
                    </Box>
                </VStack>
            </Container>

            <FooterWithFourColumns />
        </Box>
    );
};

export default Terms; 